import React from "react";
import { UserCheck, FileBarChart, ShieldCheck, LineChart, Clock, Handshake } from "lucide-react";
import { Reveal, Stagger, StaggerItem } from "../components/Reveal";

const POINTS = [
  { icon: UserCheck, t: "Dedicated Account Manager", d: "One named person who knows your catalog, your margins and your phone number." },
  { icon: FileBarChart, t: "Transparent Weekly Reporting", d: "Sales, ad spend, ACoS, account health and next actions — every week, in plain language." },
  { icon: ShieldCheck, t: "Suspension-Ready Compliance", d: "We audit the way Amazon audits, so appeals are rare — and won fast when needed." },
  { icon: LineChart, t: "Data Over Guesswork", d: "Every bid, keyword and price change backed by search-term and competitor data." },
  { icon: Clock, t: "48-Hour Response SLA", d: "Cataloging rejections, buyer escalations, listing errors — resolved inside two working days." },
  { icon: Handshake, t: "Authorised Service Partner", d: "9 years of marketplace operations across Amazon, Flipkart, Meesho, Myntra, Ajio and JioMart." },
];

export default function WhyCalium() {
  return (
    <section id="why" className="py-28 bg-[#F5D5B0]/30 border-y border-[#E5E5E5]" data-testid="why-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal className="mb-16 max-w-3xl">
          <span className="font-mono text-[11px] tracking-[0.25em] uppercase text-[#6B1414]">03 / Why Sellers Choose Calium</span>
          <h2 className="mt-4 font-heading text-4xl sm:text-5xl font-black tracking-[-0.03em] text-[#0A0A0A] leading-[0.95]">
            Built like an operations team, not an agency.
          </h2>
        </Reveal>
        <Stagger className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#0A0A0A]/10 border border-[#0A0A0A]/10">
          {POINTS.map((p, i) => (
            <StaggerItem key={p.t} data-testid={`why-point-${i}`} className="bg-[#FAFAFA] p-8 lg:p-10 group hover:bg-[#0A0A0A] transition-colors duration-500">
              <p.icon size={26} strokeWidth={1.5} className="text-[#6B1414] group-hover:text-[#C8956A] transition-colors mb-8" aria-hidden="true" />
              <h3 className="font-heading text-lg font-bold text-[#0A0A0A] group-hover:text-white mb-2 transition-colors">{p.t}</h3>
              <p className="font-body text-sm text-[#6B7280] group-hover:text-white/60 leading-relaxed transition-colors">{p.d}</p>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
}
